module.exports = __webpack_public_path__ + "static/media/chasing.5bb0ea10.svg";